import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TableComponent } from '../../shared/components/table/table.component';
import { TableColumn } from '../../core/models/column.model';
import { UserService } from '../../core/services/user.service';
import { User } from '../../core/models/user.model';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-user-management',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    RouterModule
  ],
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss'
})
export class UserManagementComponent implements OnInit {
  tableColumns: TableColumn[] = [
    { header: 'Usuario', field: 'username' },
    { header: 'Nombre Completo', field: 'fullName' },
    { header: 'Correo', field: 'email' },
    { header: 'Área', field: 'area.name' },
  ];
  users!: any

  constructor(
    private userService: UserService,
    private router: Router) { }


  ngOnInit(): void {
    this.getUser()
  }

  private getUser() {
    const module: string = 'Novedades'
    this.userService.getAll(module).subscribe({
      next: response => {
        this.users = response
      },
      error: err => {
        console.error(err)
        this.users = []
      }
    })
  }


  newUser() {
    this.router.navigate(['/user-management/create'])
      .then(success => {
        console.log('Navegación exitosa:', success);
      })
      .catch(error => {
        console.error('Error en la navegación:', error);
      });
  }


  editUser(user: any) {
    console.log('visitacion', user)
    this.router.navigate(['/user-management/edit', user.id, true])
      .then(success => {
        console.log('Navegación exitosa:', success);
      })
      .catch(error => {
        console.error('Error en la navegación:', error);
      });
  }

  onlyReadUser(user: any) {
    //'user-management/edit/:userId/:edit'
    this.router.navigate(['/user-management/edit',user.id, false])
      .then(success => {
        console.log('Navegación exitosa:', success);
      })
      .catch(error => {
        console.error('Error en la navegación:', error);
      });
  }

  //user-management/create


}
